import { ShopProducts as ShopProductsInterface } from "interfaces";
import { useTranslation } from "react-i18next";
import dynamic from "next/dynamic";

const ProductList = dynamic(
  () => import("containers/productList/productList"),
  {
    loading: () => (
      <>
        {Array.from(Array(1).keys()).map((_, index) => (
          <ProductList key={index} products={[]} loading={true} />
        ))}
      </>
    ),
  },
);
const Empty = dynamic(() => import("components/empty/empty"));

type Props = {
  products?: ShopProductsInterface;
  isLoading?: boolean;
};

export default function ShopProducts({ products, isLoading = false }: Props) {
  const { t } = useTranslation();
  if (isLoading) {
    return (
      <>
        {Array.from(Array(3).keys()).map((_, index) => (
          <ProductList key={index} products={[]} loading={isLoading} />
        ))}
      </>
    );
  }
  if (!products?.recommended?.length && !products?.all?.length) {
    return <Empty text={t("no.products.found")} />;
  }
  return (
    <>
      {!!products?.recommended?.length && (
        <ProductList
          title={t("popular")}
          products={products?.recommended || []}
          loading={isLoading}
        />
      )}
      {products?.all?.map((item) =>
        Array.isArray(item?.children) && item?.children?.length ? (
          item?.children?.map((child) => (
            <ProductList
              key={child?.id}
              products={child?.products || []}
              title={child?.translation?.title}
              uuid={child?.uuid}
            />
          ))
        ) : (
          <ProductList
            key={item?.id}
            products={item?.products || []}
            title={item?.translation?.title}
            uuid={item?.uuid}
          />
        ),
      )}
    </>
  );
}
